import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import useGetPurchasesQuotationList from '@hooks/PUR/PurchaseQuotation/useGetPurchasesQuotationList';
import NtxTable from '@components/DataTable/NtxTable';

interface Props {
  Route: 'PurchaseOrder';
}

const PurchaseQuotationList = ({ Route }: Props) => {
  const { t, i18n } = useTranslation();

  const { PurchaseQuotationList, loading, error } = useGetPurchasesQuotationList({
    PurchaseRequestId: '2c1dda50-94d6-4356-abe4-7995aa24e8ff'
  });

  const columns = [
    { title: t('Number'), key: 'code' },
    { title: t('Date'), key: 'date' },
    // { title: t('Customer'), key: 'customer' },
    { title: t('Branch'), key: 'branch' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = PurchaseQuotationList?.slice()
    ?.sort((a, b) => b?.no - a?.no)
    ?.map(item => {
      let rowClass;

   

      return {
        code: item.code,
        date: item.transactionDate?.toString().split('T')[0],
        branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,
        action: (
          <>
           
            <Link
              className='btn btn-sm btn-theme'
              to={
                Route === 'PurchaseOrder'
                  ? `/PUR/PurchaseOrder/AddPurchaseOrder/not_multi/${item.id}`
                  : Route === 'Quotation'
                  ? `/PUR/Quotation/AddPurchaseQuotation/${item.id}`
                  : Route === 'ApInvoice'
                  ? `/Finance/Ap/ApInvoices/AddApInvoices/${item.id}`
                  : ''
              }
            >
              <i className='bi bi-cart-plus me-2 '></i>
              {t('إنــشاء')}
            </Link>
          </>
        ),

        rowClass
      };
    });

  return (
    <Card>
      <Loading loading={loading}>
        <CardHeader className='d-flex justify-content-between align-items-center '>
          <h5 className='m-0'>{t('عروض الأســعار')}</h5>
        </CardHeader>
        {/* <div className="table-responsive">
            <table className="table table-hover text-nowrap">
              <thead className="bg-theme bg-opacity-30 rounded-0 p-1">
                <tr>
                  <th scope="col">{t('رقم العرض ')}</th>
                  <th scope="col">{t('تاريخ العرض ')}</th>
                  <th scope="col">{t('المورد')}</th>
                  <th scope="col">{t('الفرع ')}</th>
                  <th scope="col">{t('قيمة العرض ')}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {currentData?.map((item, index) => (
                  <tr key={item.id}>
                    <td className="align-middle"> {item.code} </td>
                    <td className="align-middle">
                      {item.transactionDate?.toString()?.split('T')[0]}
                    </td>
                    <td className="align-middle"> {item.peopleName2} </td>
                    <td className="align-middle"> {item.organizationName2} </td>
                    <td className="align-middle">{item.grossAmount} </td>
                     <td>
                      <Link
                        className="btn btn-outline-theme"
                        to={`/PurchasesTransactions/PurchaseOrder/AddPurchaseOrder/${item.id}`}
                       >
                        إنشــاء
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="p-3">
            <Pagination
              filteredData={filteredSearch}
              dataPerPage={dataPerPage}
              handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
              currentPage={currentPage}
            />
          </div> */}
        <CardBody>
          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={8}
            theadClass=''
            tableClass='table text-nowrap table-hover '
            enableSearch
            // showRecordsSelector
          />
        </CardBody>
      </Loading>
    </Card>
  );
};

export default PurchaseQuotationList;
